import i18n from 'modules/core/lib/i18n'

const UPDATE_TYPES = {
  hiring: 'hiring',
  termination: 'termination',
  contract: 'contract',
  sick: 'sick',
  parental: 'parental',
  customLeave: 'custom-leave',
  id: 'id',
  name: 'name',
  irpf: 'irpf',
  bank: 'bank',
  gender: 'gender',
  address: 'address',
  residence: 'residence',
  workplace: 'workplace',
  nationality: 'nationality',
  email: 'email',
  phoneNumber: 'phone_number',
  manualIncidence: 'manual_incidence',
} as const

type UpdateType = (typeof UPDATE_TYPES)[keyof typeof UPDATE_TYPES]

// Typed helper to make grouped arrays type-safe
const group = <T extends ReadonlyArray<UpdateType>>(...values: T) => values

export const getUpdateTypeFilterOptions = () => [
  {
    label: i18n.t(
      'compensations.employee_updates_data_collection_page.filters.update_type_options.new_hires'
    ),
    value: UPDATE_TYPES.hiring,
  },
  {
    label: i18n.t(
      'compensations.employee_updates_data_collection_page.filters.update_type_options.terminations'
    ),
    value: UPDATE_TYPES.termination,
  },
  {
    label: i18n.t(
      'compensations.employee_updates_data_collection_page.filters.update_type_options.contract_changes'
    ),
    value: UPDATE_TYPES.contract,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.all_leaves'),
    value: group(UPDATE_TYPES.sick, UPDATE_TYPES.parental, UPDATE_TYPES.customLeave),
  },
  {
    label: i18n.t(
      'compensations.employee_updates_data_collection_page.filters.update_type_options.sick_leaves'
    ),
    value: UPDATE_TYPES.sick,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.parental'),
    value: UPDATE_TYPES.parental,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.custom_leave'),
    value: UPDATE_TYPES.customLeave,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.all_personal_data'),
    value: group(
      UPDATE_TYPES.id,
      UPDATE_TYPES.name,
      UPDATE_TYPES.irpf,
      UPDATE_TYPES.bank,
      UPDATE_TYPES.gender,
      UPDATE_TYPES.address,
      UPDATE_TYPES.residence,
      UPDATE_TYPES.workplace,
      UPDATE_TYPES.nationality,
      UPDATE_TYPES.email,
      UPDATE_TYPES.phoneNumber
    ),
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.id'),
    value: UPDATE_TYPES.id,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.name'),
    value: UPDATE_TYPES.name,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.irpf'),
    value: UPDATE_TYPES.irpf,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.bank'),
    value: UPDATE_TYPES.bank,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.gender'),
    value: UPDATE_TYPES.gender,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.address'),
    value: UPDATE_TYPES.address,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.residence'),
    value: UPDATE_TYPES.residence,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.workplace'),
    value: UPDATE_TYPES.workplace,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.nationality'),
    value: UPDATE_TYPES.nationality,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.email'),
    value: UPDATE_TYPES.email,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.phone_number'),
    value: UPDATE_TYPES.phoneNumber,
  },
  {
    label: i18n.t('bookkeepers.incidence.filters.types.all_manual_incidences'),
    value: UPDATE_TYPES.manualIncidence,
  },
]

export type UpdateTypeFilterOption = ReturnType<typeof getUpdateTypeFilterOptions>[number]
